import React from 'react'
import { useLocation } from 'react-router-dom';
import { Card, CardContent, Typography, LinearProgress, Box, Button } from "@mui/material";
import { DownloadOutlined } from '@ant-design/icons';
import ProgressCard from './Components/ProgressCard';
import BenefitLogo from './Assets/Bronze.png'
import dayjs from 'dayjs';
import LIMICard from './Components/singleBenefits/LIMICard';
import GAPCard from './Components/singleBenefits/GapCard';

const SingleBenefit = () => {
    const location = useLocation();
    const benefitId = location.state?.benefitId;
    const dummyData = {
        "message": "LI Details fetched successfully",
        "error": false,
        "data": {
            "club_progress_details": {
                "id": 1,
                "title": "Gold Club",
                "logo": `${BenefitLogo}`,
                "subtitle": "current level",
                "description": {
                    "display_name": "25 to 51 MT",
                    "color": "#f49d3f"
                },
                "slider_info": {
                    "club_min_value": 25,
                    "club_max_value": 51,
                    "current_value": 30,
                    "uom": "Ton",
                    "header_text": "Progress to Platinum Club",
                    "footer_text": "100 Ton Required for next club"
                }
            },
            "benefit_details": {
                "benefit_name": "Life Insurance",
                "subtitle": "Financial Security for your Loved Ones",
                "logo": `${BenefitLogo}`,
                "status": {
                    "display_name": "Active",
                    "color": "#00b894"
                }
            },
            "policy_details": [
                {
                    "sum_assured": "₹ 1,00,000",
                    "policy_id": "1234567890",
                    "effective_Date": "01-01-2021",
                    "expiry_date": "01-01-2022",
                    "policy_document_link": `${BenefitLogo}`,
                    "ecard_link": `${BenefitLogo}`,
                    "beneficiary_details": {
                        "beneficiary_name": "John Doe",
                        "beneficiary_dob": "01-01-1990",
                        "beneficiary_phone": "01-01-1990",
                        "id_proof": "Aadhar Card",
                        "id_proof_src": "s3link"
                    },
                    "nominee_details": [
                        {
                            "nominee_name": "John Doe",
                            "nominee_dob": "01-01-1990",
                            "nominee_phone": "01-01-1990",
                            "id_proof": "Aadhar Card",
                            "id_proof_src": "s3link"
                        }
                    ]
                },
                {
                    "sum_assured": "₹ 1,00,000",
                    "policy_id": "1234567890",
                    "effective_Date": "01-01-2021",
                    "expiry_date": "01-01-2022",
                    "policy_document_link": `${BenefitLogo}`,
                    "ecard_link": `${BenefitLogo}`,
                    "beneficiary_details": {
                        "beneficiary_name": "John Doe",
                        "beneficiary_dob": "01-01-1990",
                        "beneficiary_phone": "01-01-1990",
                        "id_proof": "Aadhar Card",
                        "id_proof_src": "s3link"
                    },
                    "nominee_details": [
                        {
                            "nominee_name": "John Doe",
                            "nominee_dob": "01-01-1990",
                            "nominee_phone": "01-01-1990",
                            "id_proof": "Aadhar Card",
                            "id_proof_src": "s3link"
                        }
                    ]
                }
            ]
        },
        "formatting_args": null
    }
    // const dummyData = {
    //     "message": "GAP Details fetched successfully",
    //     "error": false,
    //     "data": {
    //         "club_progress_details": {
    //             "id": 1,
    //             "title": "Gold Club",
    //             "logo": "s3 link",
    //             "subtitle": "Current Level",
    //             "description": {
    //                 "display_name": "25 to 51 MT",
    //                 "color": "#f49d3f"
    //             },
    //             "slider_info": {
    //                 "club_min_value": 25,
    //                 "club_max_value": 51,
    //                 "current_value": 30,
    //                 "uom": "Ton",
    //                 "header_text": "Progress to Platinum Club",
    //                 "footer_text": "100 Ton required for next club"
    //             }
    //         },
    //         "benefit_details": {
    //             "benefit_name": "Golden Age Plan",
    //             "subtitle": "Retire with Confidence, Live with Freedom",
    //             "logo": "s3 link",
    //             "status": {
    //                 "display_name": "Active",
    //                 "color": "#00b894"
    //             }
    //         },
    //         "policy_details": [
    //             {
    //                 "evaluated_gross_amt": {
    //                     "value": "₹ 18,10,112.15 *",
    //                     "color": "#F59C1E"
    //                 },
    //                 "TDS_deducted_till_FY_23_24": "₹ 1,73,199.37",
    //                 "disbursed_amt_till_now": "₹ 23,560"
    //             }
    //         ],
    //         "gap_disbursed_till_now": {
    //             "total_disbursed": "₹ 23,560",
    //             "disbursed_list": [
    //                 {
    //                     "time_period": "14th March 2025",
    //                     "amount": "₹ 23,560"
    //                 }
    //             ]
    //         },
    //         "note": "*Subject to TDS under section 194R of IT Act",
    //         "fy_details": [
    //             {
    //                 "title": "FY 2024 - 2025",
                    
    //                 "details": [
    //                     {
    //                         "display_name": "Quarter 1",
    //                         "value": "N/A"
    //                     },
    //                     {
    //                         "display_name": "Quarter 2",
    //                         "value": "N/A"
    //                     },
    //                     {
    //                         "display_name": "Quarter 3",
    //                         "value": "443323232"
    //                     },
    //                     {
    //                         "display_name": "Quarter 4",
    //                         "value": "₹ 78,118.50"
    //                     },
    //                     {
    //                         "display_name": "Gross GAP accumulated till FY 24 - 25",
    //                         "value": "₹ 78,118.50 *"
    //                     },
    //                     {
    //                         "display_name": "TDS under Section 194R of IT act @10% for FY 24 - 25",
    //                         "value": "N/A"
    //                     }
    //                 ],
    //                 "previous_fyi": {
    //                     "title": "FY 2023 - 2024",
    //                     "py_details": [
    //                         {
    //                             "display_name": "Gross GAP accumulated till FY 23 - 24",
    //                             "value": "₹ 17,31,993.65"
    //                         },
    //                         {
    //                             "display_name": "TDS under Section 194R of IT act @10% till FY 23 - 24",
    //                             "value": "₹ 1,73,199.37"
    //                         },
    //                         {
    //                             "display_name": "Net GAP Accumulated till FY 23 - 24 ",
    //                             "value": "₹ 15,58,794.28"
    //                         }
    //                     ]
    //                 }
    //             },
    //             {
    //                 "title": "FY 2023 - 2024",
    //                 "details": [
    //                     {
    //                         "display_name": "Quarter 1",
    //                         "value": "N/A"
    //                     },
    //                     {
    //                         "display_name": "Quarter 2",
    //                         "value": "N/A"
    //                     },
    //                     {
    //                         "display_name": "Quarter 3",
    //                         "value": "443323232"
    //                     },
    //                     {
    //                         "display_name": "Quarter 4",
    //                         "value": "₹ 78,118.50"
    //                     },
    //                     {
    //                         "display_name": "Gross GAP accumulated till FY 24 - 25",
    //                         "value": "₹ 78,118.50 *"
    //                     },
    //                     {
    //                         "display_name": "TDS under Section 194R of IT act @10% for FY 24 - 25",
    //                         "value": "N/A"
    //                     }
    //                 ],
    //                 "previous_fyi": {
    //                     "title": "FY 2022 - 2023",
    //                     "py_details": [
    //                         {
    //                             "display_name": "Gross GAP accumulated till FY 23 - 24",
    //                             "value": "₹ 17,31,993.65"
    //                         },
    //                         {
    //                             "display_name": "TDS under Section 194R of IT act @10% till FY 23 - 24",
    //                             "value": "₹ 1,73,199.37"
    //                         },
    //                         {
    //                             "display_name": "Net GAP Accumulated till FY 23 - 24 ",
    //                             "value": "₹ 15,58,794.28"
    //                         }
    //                     ]
    //                 }
    //             }
    //         ],
    //         "formatting_args": null
    //     }
    // }
    
    const { club_progress_details, benefit_details, policy_details, gap_disbursed_till_now, fy_details, note } = dummyData.data;
    return (
        <Box sx={{ p: 2 }}>
            <LIMICard 
                benefitDetails={benefit_details}
                policyDetails={policy_details}
                clubProgressDetails={club_progress_details}
            />
            {/* <GAPCard
                benefitDetails={benefit_details}
                policyDetails={policy_details}
                clubProgressDetails={club_progress_details}
                gapDisbursed={gap_disbursed_till_now}
                fyDetails={fy_details}
                note={note}
            /> */}
        </Box>
    );
}

export default SingleBenefit